import axios, { AxiosRequestConfig } from 'axios';
import type { AlignementDto, AlignementsPayload, PoseAlignement, PoseAlignementOrganisation } from '../types/api';

const createConfig = (accessToken: string): AxiosRequestConfig => ({
    headers: {
        'Authorization': `Bearer ${accessToken}`,
        'AccessToken': accessToken,
        'Content-Type': 'application/json',
    },
});

const BASE = '/api/alignements';

/**
 * Client de `alignements` (chantier C23 SP4) : poser ou remplacer un alignement de
 * mon concept vers celui d'une autre personne, lire les miens et ceux reçus, retirer.
 * Les erreurs remontent à l'appelant (le slice reprend le message du serveur).
 */
export const alignementService = {
    lire: async (accessToken: string, entreeId?: string): Promise<AlignementsPayload> => {
        const url = entreeId ? `${BASE}?entreeId=${encodeURIComponent(entreeId)}` : BASE;
        const response = await axios.get(url, createConfig(accessToken));
        return response.data.data;
    },
    /** Deux formes : un concept lisible par une note (SP4 de C23) ou un concept d'une organisation (`cible`, C26 SP4). */
    poser: async (pose: PoseAlignement | PoseAlignementOrganisation, accessToken: string): Promise<AlignementDto> => {
        const response = await axios.post(BASE, pose, createConfig(accessToken));
        return response.data.data;
    },
    retirer: async (id: string, accessToken: string): Promise<void> => {
        await axios.delete(`${BASE}/${encodeURIComponent(id)}`, createConfig(accessToken));
    },
};

export default alignementService;
